import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, CartesianGrid, ResponsiveContainer } from 'recharts';
import { formatCount } from '../../../utils/featureUsage';

export const FEATURE_COLORS = {
    core: '#3458EA',
    pro: '#F05174',
};

function FeatureTooltip({ active, payload }) {
    if (!active || !payload || !payload.length) return null;
    const feature = payload[0].payload;
    return (
        <div className="tf-chart-tooltip">
            <strong>{feature.label}</strong>
            <span className="tf-mono">{feature.key}</span>
            <span>{`${feature.usage_pct}% · ${formatCount(feature.sites_using, feature.estimated)} sites`}</span>
            {feature.default_on && <span>On by default</span>}
        </div>
    );
}

/**
 * Horizontal bar chart of setting usage (% of sites). Core and Pro use different
 * colours; settings that are on by default are hatched.
 */
export default function FeatureUsageBarChart({ features }) {
    const height = Math.max(160, features.length * 40 + 40);

    return (
        <div className="tf-chart" style={{ height }}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={features} layout="vertical" margin={{ top: 0, right: 48, bottom: 0, left: 8 }}>
                    <defs>
                        {Object.entries(FEATURE_COLORS).map(([source, color]) => (
                            <pattern key={source} id={`tf-hatch-${source}`} width="8" height="8"
                                     patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                                <rect width="8" height="8" fill={color} />
                                <line x1="0" y1="0" x2="0" y2="8" stroke="rgba(255,255,255,0.45)" strokeWidth="3" />
                            </pattern>
                        ))}
                    </defs>
                    <CartesianGrid horizontal={false} strokeDasharray="3 3" stroke="#D8DFEC" />
                    <XAxis type="number" domain={[0, 100]} ticks={[0, 25, 50, 75, 100]}
                           tickFormatter={(v) => `${v}%`} stroke="#939CA4" fontSize={12} />
                    <YAxis type="category" dataKey="label" width={220} stroke="#939CA4" fontSize={13}
                           tickLine={false} />
                    <Tooltip content={<FeatureTooltip />} cursor={{ fill: 'rgba(147,156,164,0.12)' }} />
                    <Bar dataKey="usage_pct" radius={[0, 6, 6, 0]} barSize={22} isAnimationActive={false}
                         label={{ position: 'right', formatter: (v) => `${v}%`, fontSize: 12, fill: '#939CA4' }}>
                        {features.map((feature) => (
                            <Cell
                                key={`${feature.source}:${feature.key}`}
                                fill={feature.default_on
                                    ? `url(#tf-hatch-${feature.source})`
                                    : FEATURE_COLORS[feature.source] || FEATURE_COLORS.core}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
